import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuth } from './hooks/useAuth';
import { AuthContext } from './contexts/AuthContext';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { MatchesPage } from './pages/MatchesPage';
import { BarsPage } from './pages/BarsPage';
import { DiffusionsPage } from './pages/DiffusionsPage';
import { StoriesPage } from './pages/StoriesPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { GamificationPage } from './pages/GamificationPage';
import { LogsPage } from './pages/LogsPage';

function App() {
  const auth = useAuth();

  if (auth.loading) {
    return (
      <div className="login-page">
        <div className="spinner-lg" />
      </div>
    );
  }

  if (!auth.admin) {
    return (
      <>
        <Toaster position="bottom-right" toastOptions={{
          style: { background: '#1a1a1a', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', fontSize: '13px' },
        }} />
        <LoginPage onLogin={auth.login} />
      </>
    );
  }

  return (
    <AuthContext.Provider value={auth}>
      <BrowserRouter>
        <Toaster position="bottom-right" toastOptions={{
          style: { background: '#1a1a1a', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', fontSize: '13px' },
          success: { iconTheme: { primary: '#30D158', secondary: '#fff' } },
          error: { iconTheme: { primary: '#FF3B30', secondary: '#fff' } },
        }} />
        <Routes>
          <Route element={<Layout adminName={auth.admin.name} onLogout={auth.logout} />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/matches" element={<MatchesPage />} />
            <Route path="/bars" element={<BarsPage />} />
            <Route path="/diffusions" element={<DiffusionsPage />} />
            <Route path="/stories" element={<StoriesPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/gamification" element={<GamificationPage />} />
            <Route path="/logs" element={<LogsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;
